import type { LeadField, LeadRuleCoverage, LeadRuleFailure } from '@viq-admin/types';
import { LEAD_RULES_COPY } from './copy';

export const LEAD_FIELD_LABELS: Record<LeadField, string> = {
  first_name: 'First name',
  last_name: 'Last name',
  company: 'Company',
  title: 'Title',
  email: 'Email',
  phone: 'Phone',
  linkedin_url: 'LinkedIn',
  status: 'Status',
  temperature: 'Temperature',
};

/** "Notes 312/500", the question's wording, or the field's label. */
export function failureLabel(failure: LeadRuleFailure): string {
  switch (failure.type) {
    case 'notes_min_chars':
      return `Notes ${failure.have}/${failure.need}`;
    case 'question_answered':
      return failure.questionText;
    case 'field_present':
      return LEAD_FIELD_LABELS[failure.field];
  }
}

export function failureSummary(failures: LeadRuleFailure[]): string {
  return failures.map(failureLabel).join(' · ');
}

export function coverageLine(coverage: LeadRuleCoverage): string {
  if (coverage.questionDeleted) return LEAD_RULES_COPY.questionDeleted;
  const noun = coverage.conferenceCount === 1 ? 'conference' : 'conferences';
  const base = `Applies at ${coverage.askedAtCount} of ${coverage.conferenceCount} ${noun}`;
  if (coverage.notAskedAt.length === 0) return base;
  return `${base} · Not asked at: ${coverage.notAskedAt.map((c) => c.name).join(', ')}`;
}
